import React, { useEffect, useState} from 'react'
import Button from '@mui/material/Button';
import swal from 'sweetalert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {makeStyles} from '@mui/styles';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import AddIcon from '@mui/icons-material/Add';
import InputAdornment from '@mui/material/InputAdornment';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { create_department, create_direction, update_department, update_direction } from '../../../services/company_admin_service';


const useStyles = makeStyles((theme) => ({
    button: { margin: 8,},
    root: {
      '& > *': {
        margin: 8,
      },
    }
  }));

function Add_infos_modal({add_infos_modal,setadd_infos_modal,infos_type,update_infos,setupdate_infos,set_infos_updated,users,directions}){

    const classes = useStyles();

    const [errorText,setErrorText] = useState("");

    const [title,setTitle]=useState("");
    const [responsable,setResponsable]=useState("");
    const [direction,setDirection]=useState("");

    const [waiting,setWaiting] = useState(false);

    useEffect(()=>{
     //  console.log("users",users);
     //  console.log("directions",directions);
     //  console.log("update_infos",update_infos);
      if(update_infos){
            setTitle(update_infos.title);
            if(infos_type=="dir"){
                setResponsable(update_infos.director);
            }else{
                setResponsable(update_infos.department_manager);
                setDirection(update_infos.direction);
            }
        }
    },[]);

    function submit(){
        setErrorText('');
        if(title==="") setErrorText('Champs invalides !');
        else{
            swal({
                title: "Etes-vous sûr ?",
                text: "!!!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            })
            .then(async (willDelete) => {
              if (willDelete) {
                setWaiting(true);
                const tmp_responsable = responsable!=""?responsable:-1;
                let formData = new FormData();
                if(update_infos) formData.append('id',update_infos.id);
                formData.append('title',title);
                if(infos_type=="dir") formData.append('director',tmp_responsable);
                else{
                  formData.append('department_manager',tmp_responsable);
                  formData.append('direction',direction);
                }
                if(update_infos){
                  if(infos_type=="dir"){
                    await update_direction(formData).then((response)=>{
                     //  console.log(response.data);
                    }).catch((error)=>{
                     //  console.log(error.response);
                    })
                  }else{
                    await update_department(formData).then((response)=>{
                     //  console.log(response);
                    }).catch((error)=>{
                     //  console.log(error.response);
                    })
                  }
                  swal("Les modifications ont été apportées !", {
                    icon: "success",
                    buttons: true,
                    });
                  
                }else{
                  if(infos_type=="dir"){
                    await create_direction(formData).then((response)=>{
                     //  console.log(response.data);
                    }).catch((error)=>{
                     //  console.log(error.response);
                    })
                  }else{
                    await create_department(formData).then((response)=>{
                     //  console.log(response);
                    }).catch((error)=>{
                     //  console.log(error.response);
                    })
                  }
                  swal("L'ajout a été fait !", {
                    icon: "success",
                    buttons: true,
                    });
                }
                setadd_infos_modal(false);
                setupdate_infos(null);
                set_infos_updated(formData);
                setWaiting(false);
            }
            })
        }
    }

    return (
      <Dialog fullWidth={true} maxWidth={'md'} open={add_infos_modal} onClose={()=>{setupdate_infos(null);setadd_infos_modal(false)}} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">
            {!update_infos?"Ajouter":"Modifier"}
        </DialogTitle>
        <DialogContent>
          <div className="inputs_container">
                <TextField variant='standard' className={classes.margin} label="Titre" style={{width:"250px"}} value={title}
                    InputProps={{ startAdornment: ( <InputAdornment position="start"> <BookmarkIcon  /> </InputAdornment> ), }} onChange={(e)=>setTitle(e.target.value)} />
                <FormControl variant='standard' className="input_form">
                        <InputLabel>{infos_type=="dir"?"Directeur":"Chef de département"}</InputLabel>

                        <Select value={responsable} onChange={(e) => { setResponsable(e.target.value) }}>
                            <MenuItem value="null" disabled>
                                <em>None</em>
                            </MenuItem>
                            {
                                users.map((user) => (
                                    <MenuItem key={"user_"+user.id} value={user.id}>{user.fullName}</MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>
                    <div style={{minWidth:"250px"}}>
                        {
                          infos_type!="dir"
                          ?<FormControl variant='standard' className="input_form">
                              <InputLabel>Direction</InputLabel>
      
                              <Select value={direction} onChange={(e) => { setDirection(e.target.value) }}>
                                  <MenuItem value="null" disabled>
                                      <em>None</em>
                                  </MenuItem>
                                  {
                                      directions.map((dir) => (
                                          <MenuItem key={"dir"+dir.id} value={dir.id}>{dir.title}</MenuItem>
                                      ))
                                  }
                              </Select>
                          </FormControl>
                          :<></>
                        }
                    </div>
                    
          </div>
        </DialogContent>
        <DialogActions>
          <div className='dialogBottom'>
            <div>
                {
                    errorText === ""
                    ?<></>
                    :<p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                            {errorText}
                        </p>
                }
            </div>
            <div>
                <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={()=>{setupdate_infos(null);setadd_infos_modal(false)}}>
                    Annuler
                </Button>
                <Button variant="contained" className="submit_but valide_but" startIcon={<AddIcon />} onClick={submit} >
                   {update_infos?"Modifier":'Ajouter'}
                </Button>  
            </div>
               
          </div>
        </DialogActions>

        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={waiting}
        >
            <CircularProgress color="inherit" />
        </Backdrop>

      </Dialog>
    )
}

export default Add_infos_modal
